import { Icon } from '@iconify/react';
import { Button } from '@nextui-org/react';
import { useNavigate } from 'react-router-dom';
import { FormGenieWorker } from '../types';

interface FormGenieHeaderProps {
  formGenieWorker: FormGenieWorker | null;
  isViewingForm: boolean;
  hasGeneratedForm: boolean;
  currentFormName?: string | null;
  onBack: () => void;
}

export function FormGenieHeader({
  formGenieWorker,
  isViewingForm,
  hasGeneratedForm,
  currentFormName,
  onBack,
}: FormGenieHeaderProps) {
  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b border-default-200 bg-content1 flex-shrink-0">
      <Button
        isIconOnly
        variant="light"
        size="sm"
        onPress={onBack}
        aria-label="Back"
      >
        <Icon icon="mdi:arrow-left" width={20} />
      </Button>

      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Icon icon="mdi:form-select" width={22} className="text-blue-600 flex-shrink-0" />
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-foreground text-sm truncate">
              {formGenieWorker?.name ?? 'FormGenie'}
            </span>
            {hasGeneratedForm && currentFormName && (
              <>
                <Icon icon="mdi:chevron-right" width={16} className="text-default-400 flex-shrink-0" />
                <span className="text-sm text-default-500 truncate">{currentFormName}</span>
              </>
            )}
          </div>
          {formGenieWorker?.description && (
            <p className="text-xs text-default-400 truncate">{formGenieWorker.description}</p>
          )}
        </div>
      </div>

      {isViewingForm && (
        <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-green-100 text-green-700 text-xs flex-shrink-0">
          <Icon icon="mdi:eye" width={12} />
          Preview
        </div>
      )}
    </div>
  );
}

export default FormGenieHeader;
